import { useEffect } from 'react';

const BASE_TITLE = 'Irish Connexxion | Wholesale';

export const usePageTitle = (pageTitle) => {
  useEffect(() => {
    if (pageTitle) {
      document.title = `${pageTitle} | Irish Connexxion`;
    } else {
      document.title = BASE_TITLE;
    }
    
    // Reset to base title on unmount
    return () => {
      document.title = BASE_TITLE;
    };
  }, [pageTitle]);
};

export default usePageTitle;
